'use strict';

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var concat = require('../iterable/concat');
var getKeys = require('../utils/getKeys');
var join = require('../array/join');
var type = require('../value/type');

var filter = function filter(object, condition) {
  return getKeys(object).reduce(function (result, key) {
    if (condition(object[key], key, object)) {
      return concat(result, _defineProperty({}, key, object[key]));
    }
    return result;
  }, {});
};

module.exports = function (item, condition) {
  switch (type(item)) {
    case 'array':
      return item.filter(condition);
    case 'string':
      return join(Array.prototype.filter.call(item, condition));
    default:
      return filter(item, condition);
  }
};


//////////////////
// WEBPACK FOOTER
// ./~/fun-util/lib/iterable/filter.js
// module id = 1042
// module chunks = 37